import { render, staticRenderFns } from "./productCatalog.vue?vue&type=template&id=64b1e7d3&scoped=true&"
import script from "./productCatalog.vue?vue&type=script&lang=js&"
export * from "./productCatalog.vue?vue&type=script&lang=js&"
import style0 from "./productCatalog.vue?vue&type=style&index=0&id=64b1e7d3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b1e7d3",
  null
  
)

export default component.exports